module.exports = __webpack_public_path__ + "static/media/Photo5.517053d9.jpg";